/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { LinkEditDialogTopActions } from "cms/links/link-selector/dialog-edit/actions/link-dialog-top-actions";
import { LinkEditDetailsPanel } from "cms/links/link-selector/dialog-edit/panels/link-edit-details-panel";
import { LinkEditPlacementsPanel } from "cms/links/link-selector/dialog-edit/panels/link-edit-panel-placements";

const LinkEditPanel = () => {

    return (
        <Fragment>
            
            <LinkEditDialogTopActions />
            
            <div className='simplicity-link-edit-window-edit-panel'>
                
                <LinkEditDetailsPanel />
                
                <LinkEditPlacementsPanel />
                
            </div>
        </Fragment>
    );
};

export { LinkEditPanel };
